/** Normalize one binding for consumers that handle either cardinality. */
export const getDataAppVizFieldIds = (value) => typeof value === 'string' ? [value] : [...new Set(value ?? [])];
//# sourceMappingURL=dataAppVizFieldMapping.js.map